// src/components/store/sections/newsletter/NewsletterV13OrigamiofferSlateGold.tsx
"use client";

import React from "react";
import DynamicNewsletterVariant from "./DynamicNewsletterVariant";

export default function NewsletterV13OrigamiofferSlateGold(props: any) {
  return (
    <DynamicNewsletterVariant
      variantNumber={13}
      archKey="origami_offer"
      archLabel="Origami Ribbon Offer"
      palName="SlateGold"
      grad="from-slate-800 via-zinc-900 to-neutral-950"
      lightBg="bg-amber-50/80"
      textCol="text-amber-700"
      borderCol="border-amber-300"
      btnCls="bg-slate-900 hover:bg-slate-800"
      hexCol="#eab308"
      {...props}
    />
  );
}
